import {Component, Input, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {FormControl, FormGroup} from "@angular/forms";
import {email, required} from "@utility";
import {HELPER_ROLE_ID, ORGANIZER_ROLE_ID} from "@model";
import {AbstractComponent} from "../abstract.component";

@Component({
    selector: 'add-user-modal',
    templateUrl: './add-user-modal.component.html',
    styleUrls: ['./add-user-modal.component.scss'],
    standalone: false
})
export class AddUserModalComponent extends AbstractComponent implements OnInit {
  @Input() title: string | undefined;
  @Input() isAdmin: boolean | undefined;
  @Input() isEditUser: boolean | undefined;
  @Input() email: string | undefined;
  @Input() roleId: string | undefined;
  @Input() confirmButtonTitle: string | undefined;
  @Input() dismissButtonTitle: string | undefined;

  organizerRoleId = ORGANIZER_ROLE_ID;
  helperRoleId = HELPER_ROLE_ID;

  inputForm = new FormGroup({
    email: new FormControl(),
    role: new FormControl(),
  });

  constructor(public activeModal: NgbActiveModal) {
    super();
  }

  ngOnInit(): void {
    this.initForm();
  }

  private initForm() {
    this.inputForm.controls.email.addValidators([required, email]);
    /// if this is not for admin user then we have to select a role
    if (!this.isAdmin) {
      this.inputForm.controls.role.addValidators([required]);
    }
    // if it is edit user then we already have email and roleId(we want to change the roleId), email is not editable
    if (!this.isAdmin && this.isEditUser) {
      this.inputForm.controls.email.setValue(this.email);
      this.inputForm.controls.email.disable();
      if (this.roleId) {
        this.inputForm.controls.role.setValue(this.roleId);
      }
    }
    this.inputForm.updateValueAndValidity();
  }

  onConfirmClick(): void {
    if (this.isAdmin) {
      this.activeModal.close({email: this.inputForm.controls.email.value, roleId: undefined});
    } else {
      this.activeModal.close({email: this.inputForm.controls.email.value, roleId: this.inputForm.controls.role.value});
    }
  }

  onDismissClick(): void {
    this.activeModal.dismiss();
  }
}

export interface AddUserResult {
  email?: string,
  roleId?: number
}
